import { Component, OnInit, signal, ViewChild } from '@angular/core';
import { CommonUtil } from '../../../../../core/utils/common-util';
import { ExportActionType, TableEventType } from '../../../../../models/common/table/table-config';
import { EmployeeService } from '../../../../../state/modules/employee/services/employee.service';
import { TableComponent } from '../../../../shared/components/tables/table/table.component';
import { DEVICE_INFO_TABLE_CONSTANT } from './device-info-history.constant';

@Component({
  standalone: false,
  selector: 'kt-device-info-history',
  templateUrl: './device-info-history.component.html',
  styleUrls: ['./device-info-history.component.scss']
})
export class DeviceInfoHistoryComponent implements OnInit {

  history = signal<any[]>([]);
  data: any;

  tableOptions = DEVICE_INFO_TABLE_CONSTANT;
  showLoader = signal(false);
  lastPayload;
  totalCount = signal(0);
  @ViewChild('table', { static: false }) table: TableComponent;

  constructor(private employeeService: EmployeeService) { }

  ngOnInit() {
  }

  getDeviceInfo(payload) {
    this.showLoader.set(true);
    this.lastPayload = payload;
    this.employeeService.getDeviceInfo(payload, this.data.type, this.data.user_id).subscribe(data => {
      if (data.success) {
        this.history.set(data.data.data.active_user || []);
        this.totalCount.set(data.data.data.TotalCount || 0);
      }
      this.showLoader.set(false);
    }, (err) => {
      this.showLoader.set(false);
    });
  }

  exportInvoices(event, lastCallPayload) {
    this.showLoader.set(true);
    this.employeeService.getDeviceInfoExport(lastCallPayload, this.data.type, this.data.user_id).subscribe(data => {
      if (data.success) {
        switch (event.action) {
          case ExportActionType.EXPORT_PDF:
            this.table.exportPdf(data.data.data.active_user);
            break;
          case ExportActionType.EXPORT_EXCEL:
            this.table.exportExcel(data.data.data.active_user);
            break;
          case ExportActionType.EXPORT_CSV:
            this.table.exportCsvFile(data.data.data.active_user);
            break;
        }
      }
      this.showLoader.set(false);
    }, err => {
      this.showLoader.set(false);
    })
  }



  tableCallback(event) {
    switch (event.type) {
      // Table lazy load callback event to make api call
      case TableEventType.LAZY:
        let payload = CommonUtil.getTablePayload(event.data, this.tableOptions);
        this.getDeviceInfo(payload);
        break;
      case TableEventType.EXPORT:
        this.exportInvoices(event.data.event, this.lastPayload);
        break;
      default:
    }

    return '';
  }

}
